module.exports = __webpack_public_path__ + "img/ReSharper_icon.656aa24f.png";